import memoize from 'lodash/memoize';
import { getComputedFont } from "./getComputedFont";
export var getSystemFontFamilyMap = memoize(function () {
  var computedSystemFont = getComputedFont({
    family: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Ubuntu, sans-serif'
  });
  return {
    base: computedSystemFont,
    upper: computedSystemFont,
    mono: getComputedFont({
      family: 'Menlo, Consolas, monospace'
    })
  };
});